// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"MaxIcon_iconContainer__3zgzm","iconContainerMobile":"MaxIcon_iconContainerMobile__29PYn"};